import { render, staticRenderFns } from "./DVfieldString.vue?vue&type=template&id=6d78d194&scoped=true"
import script from "./DVfieldString.vue?vue&type=script&lang=js"
export * from "./DVfieldString.vue?vue&type=script&lang=js"
import style0 from "./DVfieldString.vue?vue&type=style&index=0&id=6d78d194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78d194",
  null
  
)

export default component.exports